export default __webpack_public_path__ + "img/cvhpgMYd.afa5d582.svg";